<template>
    <div name="booking" class="wrapper">
        
        <div class="info">
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../assets/close.png" />
            </div>
            <steps
                :isStepper="true" 
                :step=4 
            />
            <div class="contents">
                <!-- <div class="operation-info-text"><span style="font-weight: 700;">🚨 상담 가능 시간:</span> 평일 09시 ~ 18시</div> -->

                <div @click="onClick2" class="button2">
                    <span class="text2">👉🏻 마이페이지로 이동</span>
                </div>


                <div class="info-box" style="margin-top: 8px;">
                    <div class="row">
                        <img class="image" src="../assets/pin.png" />
                        <span class="title">안내</span>
                    </div>
                    <div class="row2" style="margin-top: 16px;">
                        <span class="info-box-text">비대면진료로 발급 가능한 처방전</span>
                    </div>
                    <div class="row2" style="margin-top: 8px;">
                        <div class="dot" />
                        <span class="text-normal">소모성재료 처방전</span>
                    </div>
                    <div class="row2" style="margin-top: 8px;">
                        <div class="dot" />
                        <span class="text-normal">소모성재료 처방전 (연속혈당측정용 전극)</span>
                    </div>        
                    <div class="row2" style="margin-top: 8px;">
                        <div class="dot" />
                        <span class="text-normal">의약품 처방전(인슐린, 글루카곤 등)</span>
                    </div>
                    <div class="row2" style="margin-top: 8px;">
                        <div class="dot" />
                        <span class="text-normal">세법상 장애인증명서</span>
                    </div>
                    <div class="row2" style="margin-top: 16px;">
                        <span class="info-box-text">솔닥에서 구입할 수 있는 물품</span>
                    </div>
                    <div class="row2" style="margin-top: 8px;">
                        <div class="dot" />
                        <span class="text-normal">연속혈당측정용 전극(CGM)</span>
                    </div>
                    <div class="row2" style="margin-top: 8px;">
                        <div class="dot" />
                        <span class="text-normal">주사기, 펜니들, 채혈침, 검사지, 펌프용 소모품 등</span>
                    </div>
                </div>
                <span class="row-center" style="margin-top: 30px;">그 외 궁금한 사항은 고객센터에<br>문의해 주세요!</span>
                <!-- footer -->
                <page-footer 
                    :state="0"
                />
            </div>
        </div>

        
    </div>
</template>

<script>
import Steps from '@/components/molecules/Steps';
import KakaoButton from '@/components/atoms/KakaoButton';
import PageFooter from '@/components/molecules/PageFooter';
import {mapState} from 'vuex';
import Constant from '@/constant';

export default {
    name: 'booking',
    computed: mapState(['body', 'status']),
    components: {
        Steps,
        KakaoButton,
        PageFooter
    },
    mounted: function()
    {
        ChannelIO('shutdown')
        if(!this.status.is_loading)
        {
            this.$router.push({path:"/"})
        }
        this.$store.commit(Constant.INITALIZE_DIABETES_REQUEST);
        this.topFunction();
    }, 
    methods: {
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        onClick: function()
        {
            window.open("https://pf.kakao.com/_xoDxeJG/chat", "_blank")
        },
        onClick2: function()
        {
            ChannelIO('boot', {
                "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8",
            });
            this.$router.push('/home')
            
            // ChannelIO('showMessenger');

            // location.href='tel:02-6954-7682'
            // window.open("https://solcon.channel.io/home", "_blank")
        },
        back: function()
        {
            ChannelIO('boot', {
                "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8",
            });
            this.$router.push('/home')
        }
    }
}
</script>

<style scoped>
    .operation-info-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 269px;
        height: 29px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: var(--gray-30-stroke, #E8EAEE);
    }
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .info {
        width: 100%;
        background: var(--Gray-20, #F3F5F8);
    }

    @media (min-width: 600px) {
        .info {
            width: 600px;            
        }        
    }
    .contents {
        width: 100%;
        min-height: 100vh;
        padding: 0 16px;
        box-sizing: border-box;
    }
    .info-box {
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        width: 100%;
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
        box-sizing: border-box;
    }
    .box {
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding: 2px 4px 0 4px;
    }
    .text-bold {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 23px; /* 127.778% */
    }
    
    .text-normal {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px; /* 105.556% */
        margin-left: 4px;
    }
    .text-bold-underline {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 23px; /* 127.778% */
        text-decoration-line: underline;
    }
    .title {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.6px;
        margin-left: 12px;
    }
    .image {
        width: 28px;
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .row2 {
        box-sizing: border-box;
        padding-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .dot {
        width: 9px;
        height: 9px;
        flex-shrink: 0;
        background: var(--gray-30-stroke, #E8EAEE);
        border-radius: 50%;
        margin-right: 7px;
    }
    .question {
        width: 100%;
        background: var(--Gray-00, #FFF);
        padding-top: 30px;
        padding-left: 16px;
        padding-right: 16px;
    }
    .row-flex-start {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start
    }
    .info-bold-text {
        color: #6B7684;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px; /* 110% */
    }
    .info-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .nowrap {
    
        word-break: keep-all; /* 단어 단위로 줄바꿈 허용 */
    }

    .button {   
        width: 100%;
        height: 117px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFE601;
        border-radius: 6px;
        border: 1px solid var(--Gray-50, #A3AAB6);
        cursor: pointer;
    }
    .button2 {
        border-radius: 6px;
        background: #184FA1;
        width: 100%;
        height: 61px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .image{
        width: 24px;
    }
    .text {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -0.72px;
        margin-left: 16px;
    }
    .text2 {
        color: var(--Gray-00, #FFF);
text-align: center;
font-family: Pretendard;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: normal;
letter-spacing: -0.54px;
    }
    .info-box-text {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 23px; /* 127.778% */
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding: 0 4px;
        box-sizing: border-box;
    }
    .row-center {
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px; /* 105.556% */
    }
    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
        background: var(--Gray-20, #F3F5F8);
    }
    @media (min-width: 600px) {
        .info {
            width: 600px;
        }

    }

</style>


// WEBPACK FOOTER //
// src/page/Booking.vue